import React from 'react';

export function EmptyJournalIllustration({ size = 140 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 140 140" fill="none" role="img" aria-label="Empty journal illustration">
      {/* Background circle */}
      <circle cx="70" cy="70" r="65" fill="#f0fdfa" />
      {/* Notebook */}
      <rect x="40" y="30" width="50" height="70" rx="6" fill="#01696F" />
      <rect x="40" y="30" width="7" height="70" rx="3" fill="#014f54" />
      {/* Pages */}
      <rect x="50" y="35" width="35" height="60" rx="3" fill="white" />
      {/* Lines on page */}
      <line x1="55" y1="48" x2="78" y2="48" stroke="#e2e8f0" strokeWidth="2" strokeLinecap="round" />
      <line x1="55" y1="56" x2="75" y2="56" stroke="#e2e8f0" strokeWidth="2" strokeLinecap="round" />
      <line x1="55" y1="64" x2="72" y2="64" stroke="#e2e8f0" strokeWidth="2" strokeLinecap="round" />
      {/* Pencil */}
      <g transform="translate(85, 55) rotate(30)">
        <rect x="0" y="0" width="6" height="35" rx="1" fill="#f97316" />
        <polygon points="0,35 6,35 3,42" fill="#fbbf24" />
        <rect x="0" y="0" width="6" height="5" rx="1" fill="#ec4899" />
      </g>
      {/* Sparkles */}
      <path d="M100 25 L101.5 29 L105.5 30.5 L101.5 32 L100 36 L98.5 32 L94.5 30.5 L98.5 29 Z" fill="#eab308" />
      <path d="M35 85 L36 87.5 L38.5 88.5 L36 89.5 L35 92 L34 89.5 L31.5 88.5 L34 87.5 Z" fill="#eab308" opacity="0.5" />
    </svg>
  );
}

export function SearchEmptyIllustration({ size = 140 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 140 140" fill="none" role="img" aria-label="No search results illustration">
      {/* Background circle */}
      <circle cx="70" cy="70" r="65" fill="#eff6ff" />
      {/* Magnifying glass */}
      <circle cx="60" cy="58" r="25" stroke="#3b82f6" strokeWidth="4" fill="white" />
      <line x1="78" y1="76" x2="100" y2="98" stroke="#3b82f6" strokeWidth="5" strokeLinecap="round" />
      {/* Question mark inside */}
      <text x="60" y="66" textAnchor="middle" fontSize="28" fontWeight="700" fill="#93c5fd" fontFamily="Arial">?</text>
      {/* Small dots */}
      <circle cx="30" cy="45" r="3" fill="#3b82f6" opacity="0.2" />
      <circle cx="105" cy="40" r="4" fill="#3b82f6" opacity="0.15" />
      <circle cx="110" cy="85" r="2.5" fill="#3b82f6" opacity="0.25" />
    </svg>
  );
}

export function OnboardingIllustration({ size = 80 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 80 80" fill="none" role="img" aria-label="Onboarding checklist illustration">
      {/* Clipboard */}
      <rect x="18" y="12" width="44" height="56" rx="5" fill="#01696F" />
      <rect x="28" y="6" width="24" height="10" rx="5" fill="#014f54" />
      <rect x="23" y="22" width="34" height="40" rx="3" fill="white" />
      {/* Checkmark lines */}
      <circle cx="30" cy="32" r="4" fill="#22c55e" />
      <path d="M28 32 L29.5 33.5 L33 30" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <line x1="38" y1="32" x2="52" y2="32" stroke="#e2e8f0" strokeWidth="2" strokeLinecap="round" />
      <circle cx="30" cy="44" r="4" stroke="#e2e8f0" strokeWidth="1.5" fill="white" />
      <line x1="38" y1="44" x2="50" y2="44" stroke="#e2e8f0" strokeWidth="2" strokeLinecap="round" />
      <circle cx="30" cy="56" r="4" stroke="#e2e8f0" strokeWidth="1.5" fill="white" />
      <line x1="38" y1="56" x2="48" y2="56" stroke="#e2e8f0" strokeWidth="2" strokeLinecap="round" />
      {/* Sparkle */}
      <path d="M62 15 L63.5 19 L67.5 20.5 L63.5 22 L62 26 L60.5 22 L56.5 20.5 L60.5 19 Z" fill="#eab308" />
    </svg>
  );
}
